import { PackagingFlowDirection } from './queries/api/types';

export enum AppPermission {
    dashboard = 'dashboard',
}

export const LOCATION_TYPE = {
    MAGASIN: 'Magasin',
    SCA: 'SCA',
    PARC_PALETTE: 'Parc palette',
    PRESTATAIRE: 'Prestataire',
    FOURNISSEUR: 'Fournisseur',
    ENTREPOT: 'Entrepôt',
    UNKNOWN: 'Unknown', // Added a constant for the unknown status
    ALL: 'All',
    TRANSPORTEUR: 'Transporteur',
};

type FlowTypeProps = {
    label: string;
    recipientType: string;
    senderType: string;
    tagClass: string;
};

export const PackagingFlowTypeMap = new Map<PackagingFlowDirection, FlowTypeProps>([
    [
        PackagingFlowDirection.ShippedToStore,
        {
            label: 'Expédié vers magasin',
            recipientType: LOCATION_TYPE.MAGASIN,
            senderType: LOCATION_TYPE.ENTREPOT,
            tagClass: 'tag-pink',
        },
    ],
    [
        PackagingFlowDirection.RecivedInStore,
        {
            label: 'Réceptionné en magasin',
            recipientType: LOCATION_TYPE.MAGASIN,
            senderType: LOCATION_TYPE.ENTREPOT,
            tagClass: 'tag-orange',
        },
    ],
    [
        PackagingFlowDirection.ShippedToOrganization,
        {
            label: 'Expédié par le magasin',
            recipientType: LOCATION_TYPE.SCA,
            senderType: LOCATION_TYPE.MAGASIN,
            tagClass: 'tag-green',
        },
    ],
    [
        PackagingFlowDirection.RecivedInOrganization,
        {
            label: 'Réceptionné en parc palettes',
            recipientType: LOCATION_TYPE.PARC_PALETTE,
            senderType: LOCATION_TYPE.MAGASIN,
            tagClass: 'tag-yellow',
        },
    ],
    [
        PackagingFlowDirection.ReceivedFromSupplier,
        {
            label: 'Réceptionné en magasin du fournisseur',
            recipientType: LOCATION_TYPE.MAGASIN,
            senderType: LOCATION_TYPE.TRANSPORTEUR,
            tagClass: 'tag-grey',
        },
    ],
    [
        PackagingFlowDirection.Purchase,
        {
            label: "Achat d'emballages",
            recipientType: LOCATION_TYPE.PARC_PALETTE,
            senderType: LOCATION_TYPE.PRESTATAIRE,
            tagClass: 'tag-purple',
        },
    ],
    [
        PackagingFlowDirection.Sale,
        {
            label: "Vente d'emballage",
            recipientType: LOCATION_TYPE.PRESTATAIRE,
            senderType: LOCATION_TYPE.PARC_PALETTE,
            tagClass: 'tag-purple',
        },
    ],
    [
        PackagingFlowDirection.Destruction,
        {
            label: 'Destruction de palettes',
            recipientType: LOCATION_TYPE.PARC_PALETTE,
            senderType: LOCATION_TYPE.PARC_PALETTE,
            tagClass: 'tag-purple',
        },
    ],
    [
        PackagingFlowDirection.ShipmentForRepair,
        {
            label: 'Expédition en réparation des emballages',
            recipientType: LOCATION_TYPE.PRESTATAIRE,
            senderType: LOCATION_TYPE.PARC_PALETTE,
            tagClass: 'tag-purple',
        },
    ],
    [
        PackagingFlowDirection.ReceptionFromRepair,
        {
            label: 'Réception des emballages réparés',
            recipientType: LOCATION_TYPE.PARC_PALETTE,
            senderType: LOCATION_TYPE.PRESTATAIRE,
            tagClass: 'tag-purple',
        },
    ],
    [
        PackagingFlowDirection.ReturnToSupplier,
        {
            label: "Rendu d'emballages au Transporteur",
            recipientType: LOCATION_TYPE.TRANSPORTEUR,
            senderType: LOCATION_TYPE.PARC_PALETTE,
            tagClass: 'tag-green',
        },
    ],
    [
        PackagingFlowDirection.Transfer,
        {
            label: "Transfert d'une entité à une autre",
            recipientType: LOCATION_TYPE.UNKNOWN,
            senderType: LOCATION_TYPE.UNKNOWN,
            tagClass: 'tag-pink',
        },
    ],
    [
        PackagingFlowDirection.ReceivedFromSupplierAtOrganization,
        {
            label: 'Réceptionné en entrepôt du fournisseur',
            recipientType: LOCATION_TYPE.ENTREPOT,
            senderType: LOCATION_TYPE.TRANSPORTEUR,
            tagClass: 'tag-grey',
        },
    ],
    [
        PackagingFlowDirection.DebtReduction,
        {
            label: "Réduction dette suite expiration bon d'emballages",
            recipientType: LOCATION_TYPE.TRANSPORTEUR,
            senderType: LOCATION_TYPE.SCA,
            tagClass: 'tag-yellow',
        },
    ],
    [
        PackagingFlowDirection.Increase,
        {
            label: 'Ajustement interne positif',
            recipientType: LOCATION_TYPE.UNKNOWN,
            senderType: LOCATION_TYPE.UNKNOWN,
            tagClass: 'tag-green',
        },
    ],
    [
        PackagingFlowDirection.Decrease,
        {
            label: 'Ajustement interne négatif',
            recipientType: LOCATION_TYPE.UNKNOWN,
            senderType: LOCATION_TYPE.UNKNOWN,
            tagClass: 'tag-red',
        },
    ],
    [
        PackagingFlowDirection.AutomaticReception,
        {
            label: 'Réceptionné automatiquement en magasin',
            recipientType: LOCATION_TYPE.MAGASIN,
            senderType: LOCATION_TYPE.ENTREPOT,
            tagClass: 'tag-pinktone',
        },
    ],
]);

export const TypeofMovements = [
    { name: 'Purchase', label: "Achat d'emballages" },
    { name: 'Sale', label: "Vente d'emballages" },
    { name: 'Destruction', label: 'Destruction de palettes' },
    { name: 'ShipmentToRepair', label: 'Expédition en réparation des emballages' },
    { name: 'ReceptionToRepair', label: 'Réception des emballages réparés' },
    { name: 'Transfer', label: "Transfert d'une entité à une autre" },
    { name: 'Increase', label: 'Ajustement interne positif' },
    { name: 'Decrease', label: 'Ajustement interne négatif' },
];

export const PALLET_MOVEMENT_FLOW_TYPES = [
    PackagingFlowDirection.Purchase,
    PackagingFlowDirection.ReceptionFromRepair,
    PackagingFlowDirection.Sale,
    PackagingFlowDirection.Destruction,
    PackagingFlowDirection.ShipmentForRepair,
    PackagingFlowDirection.Transfer,
    PackagingFlowDirection.Increase,
    PackagingFlowDirection.Decrease,
];

export const SENDER_RECEIVER_MOVEMENT_TYPES = ['Transfer', 'Increase', 'Decrease'];
